"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ua_parser_js_1 = require("ua-parser-js");

var Versioning_1 = require("../versioning/Versioning");

var flattenEventAttributes_1 = require("./flattenEventAttributes");

var DefaultEventController = /*#__PURE__*/function () {
  function DefaultEventController(audioVideoController, eventReporter) {
    _classCallCheck(this, DefaultEventController);

    var _a, _b, _c, _d, _e, _f, _g;

    this.audioVideoController = audioVideoController;
    this.eventReporter = eventReporter;
    /** @internal */

    this.meetingHistoryStates = [];

    try {
      this.parserResult = navigator && navigator.userAgent ? new ua_parser_js_1.UAParser(navigator.userAgent).getResult() : null;
    } catch (error) {
      // This seems to never happen with ua-parser-js in reality, even with malformed strings.

      /* istanbul ignore next */
      audioVideoController.logger.error(error.message);
    }

    this.browserMajorVersion = ((_c = (_b = (_a = this.parserResult) === null || _a === void 0 ? void 0 : _a.browser) === null || _b === void 0 ? void 0 : _b.version) === null || _c === void 0 ? void 0 : _c.split('.')[0]) || DefaultEventController.UNAVAILABLE;
    this.browserName = ((_d = this.parserResult) === null || _d === void 0 ? void 0 : _d.browser.name) || DefaultEventController.UNAVAILABLE;
    this.browserVersion = ((_e = this.parserResult) === null || _e === void 0 ? void 0 : _e.browser.version) || DefaultEventController.UNAVAILABLE;
    this.deviceName = [((_f = this.parserResult) === null || _f === void 0 ? void 0 : _f.device.vendor) || '', ((_g = this.parserResult) === null || _g === void 0 ? void 0 : _g.device.model) || ''].join(' ').trim() || DefaultEventController.UNAVAILABLE;
  }

  _createClass(DefaultEventController, [{
    key: "publishEvent",
    value: function publishEvent(name, attributes) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var timestampMs, eventAttributes;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                timestampMs = Date.now();
                this.meetingHistoryStates.push({
                  name: name,
                  timestampMs: timestampMs
                }); // Make a single frozen copy of the event, reusing the object returned by
                // `getAttributes` to avoid copying too much.

                eventAttributes = Object.freeze(Object.assign(this.getAttributes(timestampMs), attributes));
                this.audioVideoController.forEachObserver(function (observer) {
                  if (observer.eventDidReceive) {
                    observer.eventDidReceive(name, eventAttributes);
                  }
                });
                this.reportEvent(name, timestampMs, attributes);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "reportEvent",
    value: function reportEvent(name, timestampMs, attributes) {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var flattenedAttributes;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (attributes) {
                  flattenedAttributes = flattenEventAttributes_1.default(attributes);
                }

                _context2.next = 4;
                return (_a = this.eventReporter) === null || _a === void 0 ? void 0 : _a.reportEvent(timestampMs, name, flattenedAttributes);

              case 4:
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);

                /* istanbul ignore next */
                this.audioVideoController.logger.error("Error reporting event ".concat(_context2.t0));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));
    }
  }, {
    key: "pushMeetingState",
    value: function pushMeetingState(state) {
      var timestampMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.meetingHistoryStates.push({
                  name: state,
                  timestampMs: timestampMs
                });
                this.reportEvent(state, timestampMs);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getAttributes",
    value: function getAttributes(timestampMs) {
      var _a, _b;

      return {
        attendeeId: this.audioVideoController.configuration.credentials.attendeeId,
        browserMajorVersion: this.browserMajorVersion,
        browserName: this.browserName,
        browserVersion: this.browserVersion,
        deviceName: this.deviceName,
        externalMeetingId: typeof this.audioVideoController.configuration.externalMeetingId === 'string' ? this.audioVideoController.configuration.externalMeetingId : '',
        externalUserId: this.audioVideoController.configuration.credentials.externalUserId,
        meetingHistory: this.meetingHistoryStates,
        meetingId: this.audioVideoController.configuration.meetingId,
        osName: ((_a = this.parserResult) === null || _a === void 0 ? void 0 : _a.os.name) || DefaultEventController.UNAVAILABLE,
        osVersion: ((_b = this.parserResult) === null || _b === void 0 ? void 0 : _b.os.version) || DefaultEventController.UNAVAILABLE,
        sdkVersion: Versioning_1.default.sdkVersion,
        sdkName: Versioning_1.default.sdkName,
        timestampMs: timestampMs
      };
    }
  }]);

  return DefaultEventController;
}();

exports.default = DefaultEventController;
/** @internal */

DefaultEventController.UNAVAILABLE = 'Unavailable';